import React from "react";
import CreateInputText from "./create-input-text";
import InternationalPhoneField from "@pano-project/components/PhoneInput/InternationalPhoneField";

const INTERNATIONAL_PHONE_LAYOUTS = ["panoramic", "amount-first"];

const CreateInputPhone = (props) => {
  const { layout, isPixV2 } = props;

  if (isPixV2 || !INTERNATIONAL_PHONE_LAYOUTS.includes(layout)) {
    return <CreateInputText {...props} />;
  }

  return <InternationalPhoneField {...props} />;
};

export default CreateInputPhone;
